export enum Tabs {
    Shape = "shape",
    Colour = "colour",
    Pattern = "pattern",
    Stickers = "stickers",
}

export enum PlanterShape {
    CoffeeTin = "coffee-tin",
    RainBoot = "old-boot",
    WateringCan = "watering-can",
    Bucket = "bucket",
    PBJar = "peanut-butter-jar",

    None = "",
}

export enum PlanterColour {
    Red = "red",
    Orange = "orange",
    Yellow = "yellow",
    Green = "green",
    Purple = "purple",
    Blue = "blue",

    None = "white",
}

export enum PlanterPattern {
    Chevron = "chevron",
    PolkaDots = "polkadots",
    Stripes = "stripes",
    Shapes = "shapes",
    Zebra = "zebra",
    Confetti = "confetti",

    None = "large",
}

export enum PlanterSticker {
    Sticker1 = "bottle-cap",
    Sticker2 = "bow",
    Sticker3 = "lightning-bolt",
    Sticker4 = "purple-star",
    Sticker5 = "ribbon",
    Sticker6 = "rainbow",

    None = "",
}

export class GameState {
    public static shape: PlanterShape;
    public static colour: PlanterColour;
    public static pattern: PlanterPattern;
    public static sticker: PlanterSticker;

    public static round = 1;
    public static roundStartTime = 0;
    public static reset() {
        GameState.shape = PlanterShape.None;
        GameState.colour = PlanterColour.None;
        GameState.pattern = PlanterPattern.None;
        GameState.sticker = PlanterSticker.None;
    }
}
